// extracted by css-extract-rspack-plugin
export default {"tabs":"ManageBatchPanel-module__tabs__FKv92","commentsHeading":"ManageBatchPanel-module__commentsHeading__Wij2L"};